export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filter-search.vue?vue&type=template&id=872d937a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter-search/filter-search.vue?vue&type=template&id=872d937a&
// module id = 1045
// module chunks = 0